import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import DisplayEnv from 'components/theme/display-env';

export default function FreatureFormToggle({
  feature,
  flag,
  onSubmit,
  onFormClose
}) {
  const { key, description } = feature;
  const { enable, environment } = flag;

  const onSubmitToggle = () => {
    onSubmit({ key, description, enable: !enable });
  };

  return (
    <>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          This will turn <b>{enable ? 'off' : 'on'}</b> the <b>{key}</b> flag in
          the <DisplayEnv environment={environment} /> environment.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onFormClose}
          color="secondary"
          name="cancel"
          data-testid="cancel-form"
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmitToggle}
          color="primary"
          variant="contained"
          data-testid="submit-form"
        >
          {enable ? 'Turn Off' : 'Turn On'}
        </Button>
      </DialogActions>
    </>
  );
}
